import type { AttrSchemaField } from '../../api/itemAttrs';

interface Props {
  field: AttrSchemaField;
  values: string[];
  onChange: (values: string[]) => void;
}

export function AttrField({ field, values, onChange }: Props) {
  const options = field.options ?? [];
  const selected = new Set(values.map((v) => v.trim()).filter(Boolean));

  if (field.multi) {
    return (
      <div className="block text-xs text-[var(--muted)]">
        <div className="mb-1.5">{field.label}（可多选）</div>
        <div className="flex flex-wrap gap-1.5">
          {options.map((opt) => {
            const on = selected.has(opt);
            return (
              <button
                key={opt}
                type="button"
                className={`text-[11px] px-2 py-1 rounded border transition-colors ${
                  on
                    ? 'bg-[var(--ink)] text-white border-[var(--ink)]'
                    : 'bg-[var(--paper)] text-[var(--text)] border-[var(--line)] hover:border-[var(--line-strong)]'
                }`}
                onClick={() => {
                  const next = new Set(selected);
                  if (on) next.delete(opt);
                  else next.add(opt);
                  onChange([...next]);
                }}
              >
                {opt}
              </button>
            );
          })}
        </div>
        {options.length === 0 && (
          <input
            className="mt-1.5 w-full text-sm border border-[var(--line)] rounded px-2 py-1.5 text-[var(--ink)]"
            value={values.join(', ')}
            onChange={(e) =>
              onChange(
                e.target.value
                  .split(/[,，]/)
                  .map((s) => s.trim())
                  .filter(Boolean)
              )
            }
            placeholder="逗号分隔"
          />
        )}
        {values.some((v) => v && !options.includes(v)) && options.length > 0 && (
          <div className="mt-1.5 text-[10px] text-[var(--muted)]">
            自定义值：{values.filter((v) => v && !options.includes(v)).join(', ')}
          </div>
        )}
      </div>
    );
  }

  const current = values[0] ?? '';
  const known = options.includes(current) || current === '';

  return (
    <label className="block text-xs text-[var(--muted)]">
      {field.label}
      {options.length > 0 ? (
        <select
          className="mt-1 w-full text-sm border border-[var(--line)] rounded px-2 py-1.5 text-[var(--ink)] bg-[var(--paper)]"
          value={known ? current : '__custom__'}
          onChange={(e) => {
            const v = e.target.value;
            if (v === '__custom__') return;
            onChange(v ? [v] : []);
          }}
        >
          <option value="">未设置</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
          {!known && current && <option value="__custom__">{current}（自定义）</option>}
        </select>
      ) : (
        <input
          className="mt-1 w-full text-sm border border-[var(--line)] rounded px-2 py-1.5 text-[var(--ink)]"
          value={current}
          onChange={(e) => onChange(e.target.value.trim() ? [e.target.value.trim()] : [])}
        />
      )}
    </label>
  );
}
